import { useEffect } from "react";
import { showLoader, hideLoader } from "./brandLoader";

/**
 * Shows the Education Department loader while mounted. Used for the Redux
 * `loading` flag, route code-splitting fallbacks and the SSO landing page.
 */
const Loader = () => {
    useEffect(() => {
        showLoader();
        return () => hideLoader();
    }, []);
    return null;
};

export default Loader;
